import { render, staticRenderFns } from "./create.vue?vue&type=template&id=3fdc5686&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=3fdc5686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc5686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdc5686')) {
      api.createRecord('3fdc5686', component.options)
    } else {
      api.reload('3fdc5686', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=3fdc5686&scoped=true&", function () {
      api.rerender('3fdc5686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/create.vue"
export default component.exports